/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolveDuplicateResidentListEntry
 */
export interface ResolveDuplicateResidentListEntry {
    /**
     * 
     * @type {string}
     * @memberof ResolveDuplicateResidentListEntry
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResolveDuplicateResidentListEntry
     */
    archive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResolveDuplicateResidentListEntry
     */
    ignore_duplicates?: boolean;
}

/**
 * Check if a given object implements the ResolveDuplicateResidentListEntry interface.
 */
export function instanceOfResolveDuplicateResidentListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "archive" in value;

    return isInstance;
}

export function ResolveDuplicateResidentListEntryFromJSON(json: any): ResolveDuplicateResidentListEntry {
    return ResolveDuplicateResidentListEntryFromJSONTyped(json, false);
}

export function ResolveDuplicateResidentListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveDuplicateResidentListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'archive': json['archive'],
        'ignore_duplicates': !exists(json, 'ignore_duplicates') ? undefined : json['ignore_duplicates'],
    };
}

export function ResolveDuplicateResidentListEntryToJSON(value?: ResolveDuplicateResidentListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'archive': value.archive,
        'ignore_duplicates': value.ignore_duplicates,
    };
}

